{
  "instances": {
    "configprops": {
      "label": "Stillingareiginleikar",

      "no_properties_set": "Engin stilling í boði."
    }
  }
}
